var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form-designer",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "dbDesignerRef",
      staticClass: "visual-design",
      attrs: { "designer-config": _vm.designerConfig },
      on: { changeTitle: _vm.changeTitle },
    },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
        _c("i", {
          staticClass: "iconfont iconbianji3",
          on: { click: _vm.editFn },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-button",
            { staticClass: "view-btn", on: { click: _vm.previewDesign } },
            [_c("el-icon", [_c("View")]), _vm._v("预览\n    ")],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { staticClass: "clear-btn", on: { click: _vm.clearCanvas } },
            [_c("el-icon", [_c("ElIconDelete")], 1), _vm._v("清空\n    ")],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveDesign } },
            [_c("el-icon", [_c("Finished")], 1), _vm._v("保存\n    ")],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }